import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid-pro";

export function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport
        csvOptions={{
          fileName: "PHIL FILE Traceability Report",
          utf8WithBom: true,
          delimiter: ";"
        }}
      />
    </GridToolbarContainer>
  );
}
